import './App.css';
import {Route, Routes} from 'react-router-dom';
import {NotificationContainer} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";
import SignUpPage from "./pages/SignUpPage";
import React from "react";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminPage from "./pages/AdminPage";
import ContactPage from "./pages/ContactPage";
import GenerateApkPage from "./pages/GenerateApkPage";
import LogoPage from "./pages/LogoPage";
import CookieNotice from "./components/CookieNotice";
import ReportCompaniesPage from "./pages/ReportCompaniesPage";
import ReportMediaPage from "./pages/ReportMediaPage";

function App() {
    return (
        <>
        <Routes>
            <Route path="/" element={<DashboardPage/>}/> {/* Make sure this Route is here */}
            <Route path="/login" element={<LoginPage bodyClass='login-page' />}/>
            <Route path="/sign-up" element={<SignUpPage bodyClass='register-page' />}/>

            <Route path="/admin/*" element={<ProtectedRoute component={AdminPage}/>}/>
            <Route path="/contact" element={<ProtectedRoute component={ContactPage}/>}/>
            <Route path="/logo" element={<ProtectedRoute component={LogoPage}/>}/>
            <Route path="/generate-apk" element={<ProtectedRoute component={GenerateApkPage}/>}/>

            {/* Rapoarte (super-admin). ProtectedRoute verifica doar autentificarea;
                rolul e verificat de endpoint-urile /api/v1/admin/* si de meniu. */}
            <Route path="/rapoarte/companii" element={<ProtectedRoute component={ReportCompaniesPage}/>}/>
            <Route path="/rapoarte/moderare" element={<ProtectedRoute component={ReportMediaPage}/>}/>

        </Routes>
        <NotificationContainer/>
        <CookieNotice/>
        </>
    );
}

export default App;
